import axios from "axios";

axios.defaults.baseURL = "https://opapi.yikeyin.com";

/**
 * 登录
 */

export const accountLogin = (tel, password) =>
  axios.post("wx/login", {
      tel,
      password
    })
    .then(function(response) {
      console.log(response);
      return response;
    })
    .catch(function(error) {
      console.log(error);
    });

/**
 * 获取待办事项
 */

export const getToDo = tel =>
  axios
    .get("wx/tasks?tel=" + tel)
    .then(function(response) {
      return response;
    })
    .catch(function(error) {
      console.log(error);
    });

export const getIsSchool = tel =>
  axios
    .get("wx/isSchool?tel=" + tel)
    .then(function(response) {
      return response;
    })
    .catch(function(error) {
      console.log(error);
    });

/**
 * 获取点位
 */

export const getPoints = tel =>
  axios
    .get("wx/points?tel=" + tel)
    .then(function(response) {
      return response;
    })
    .catch(function(error) {
      console.log(error);
    });
/**
 * 处理任务
 */

export const updateToDo = (id, tel) =>
  axios
    .post("wx/deal", {
      terminal: id,
      tel
    })
    .then(function(response) {
      return response;
    })
    .catch(function(error) {
      console.log(error);
    });

/**
 * 获取所有设备分组
 */

export const getGroups = tel =>
  axios
    .get("wx/groups?tel="+tel)
    .then(function(response) {
      return response;
    })
    .catch(function(error) {
      console.log(error);
    });

/**
 * 获取所有设备列表
 */

export const getMachineList = tel =>
  axios
    .get("wx/terminals?tel="+tel)
    .then(function(response) {
      return response;
    })
    .catch(function(error) {
      console.log(error);
    });

export const apply = (data) =>
  axios
    .post("supply/apply", data)
    .then(function(response) {
      return response;
    })
    .catch(function(error) {
      console.log(error);
    });

export const addPaper = (data) =>
  axios
    .post("wx/add-paper", data)
    .then(function(response) {
      return response;
    })
    .catch(function(error) {
      console.log(error);
    });



// WEBPACK FOOTER //
// ./src/service/index.js